import { useLocalStorage } from '@vueuse/core'
import { getIsInternational } from '@/utils/internationality'
import { LANGUAGE_KEY, langCodeList, getDefaultLanguage, compLangModuleMap } from '@/locales/index'

export const useLanguage = () => {
  const isForeign = getIsInternational()

  /** 默认语言 */
  const defaultLanguage = getDefaultLanguage()
  /** 当前语言环境 */
  const curLanguage = useLocalStorage(LANGUAGE_KEY, isForeign ? 'en' : 'cn')

  /**
   * 切换语言
   * @param lang 本地命名的语言code
   */
  const changeLanguage = (lang: string) => {
    // 如果切换的语言不在langCodeList里则使用默认语言。
    if (!langCodeList.includes(lang)) lang = defaultLanguage
    curLanguage.value = lang
  }

  /**
   * 获取组件的国际化语言
   */
  const getComponentsLocale = computed(() => {
    return compLangModuleMap.get(unref(curLanguage))?.default ?? {}
  })

  return { defaultLanguage, curLanguage, changeLanguage, getComponentsLocale }
}
